// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_2p7YSM_sbOEk4KQ8RGosCm"};